import FontFaceObserver from 'fontfaceobserver';
import Cookies from 'js-cookie';

const FONTS = {
	'Open Sans': [
		{
			weight: 300,
			style: 'normal',
		},
		{
			weight: 400,
			style: 'normal',
		},
		{
			weight: 700,
			style: 'normal',
		},
	],
	'Vafle': [
		{
			weight: 400,
			style: 'normal',
		},
	],
};

const onLoaded = () => {
	document.documentElement.className += ' fonts-loaded';
	Cookies.set('fontsLoaded', 'true', {
		expires: 7,
	});
};

const onFail = () => {
	document.documentElement.className += ' fonts-failed';
};

const getLoaders = () => {
	const loaders = [];

	Object.keys(FONTS).forEach((font) => {
		const variants = FONTS[font].map((variant) => new FontFaceObserver(font, variant).load());

		loaders.push(...variants);
	});

	return loaders;
};


export const fontLoader = Promise.all(getLoaders());

export const init = () => {
	if (Cookies.get('fontsLoaded') === 'true') {
		return;
	}

	return fontLoader
		.then(onLoaded)
		.catch(onFail);
};
